module.exports = __webpack_public_path__ + "mt.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/mt.svg
// module id = 707
// module chunks = 0